"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Currency = void 0;
var honeycomb_1 = require("@honeycomb-npm/honeycomb");
var PropTypes = require("prop-types");
var React = require("react");
var Currency = function (props) {
    var display = honeycomb_1.Formatters.formatCurrency(props.value, props.currency, props.type, props.decimals);
    var screenreader = honeycomb_1.Formatters.formatCurrency(props.value, props.currency, 'name', props.decimals);
    return (React.createElement("span", { className: "honeycomb-currency" },
        React.createElement("span", { "aria-hidden": "true" }, display),
        React.createElement("span", { className: "sr-only" }, screenreader)));
};
exports.Currency = Currency;
exports.Currency.defaultProps = {
    currency: 'AUD',
    decimals: 2,
    type: 'symbol',
};
exports.Currency.propTypes = {
    currency: PropTypes.string,
    decimals: PropTypes.number,
    type: PropTypes.oneOf(['code', 'name', 'symbol']),
    value: PropTypes.number.isRequired,
};
